<ng-container *ngIf="!loading">
  <div class="flats-container">

    <div class="flats-container-info">
      <span class="floor-title">Этаж</span>
      <span class="spot-info">Пятно 1-72 / Д 12</span>
      <div class="btn btn-change" (click)="noChanges()">
          Изменений не было
        </div>
    </div>

    <div class="flats-container-box">

      <div class="box-left">
        <ng-container *ngIf="otherRoom203 || otherRoomMansard">
          <div class="other" *ngIf="otherRoom203">
              {{otherRoom203?.title}}
          </div>
          <div class="other" *ngIf="otherRoomMansard">
            {{otherRoomMansard?.title}}
          </div>
        </ng-container>
        <ng-container *ngIf="!otherRoom203 && !otherRoomMansard">
          <div class="other">
          </div>
        </ng-container>
        <div class="floor" *ngFor="let floor of set1">
          {{floor?.floorID}}
        </div>
        <div class="other" *ngIf="otherRoom201">
          {{otherRoom201?.title}}
        </div>
        <div class="other" *ngFor="let other1 of otherRooms1">
          {{other1?.title}}
        </div>
        <div class="other" *ngIf="otherRoom202">
          {{otherRoom202?.title}}
        </div>
        <div class="other" *ngFor="let other3 of otherRooms3">
          {{other3?.title}}
        </div>
      </div>

      <div class="box-right">

        <div class="box-right__inner">

          <ng-container *ngIf="otherRoom203 || otherRoomMansard">
            <div class="other-rooms" (click)="openOtherRoom(otherRoom203)" *ngIf="otherRoom203">
              <div class="row">
                <span> {{otherRoom203?.info?.placeCount ? otherRoom203?.info?.placeCount : '-'}} мест</span>
                <span> {{otherRoom203?.info?.area ? otherRoom203?.info?.area : '-'}} кв.м.</span>
              </div>
            </div>
  
            <div class="other-rooms" (click)="openOtherRoom(otherRoomMansard)" *ngIf="otherRoomMansard">
              <div class="row">
                <span> {{otherRoomMansard?.info?.placeCount ? otherRoomMansard?.info?.placeCount : '-'}} комнат</span>
                <span> {{otherRoomMansard?.info?.area ? otherRoomMansard?.info?.area : '-'}} кв.м.</span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!otherRoom203 && !otherRoomMansard">
            <div class="other-rooms">
              <div class="row white">
              </div>
            </div>
          </ng-container>

          <div class="floor-row" *ngFor="let floor of obj">
            <div class="floor-row-inner" *ngFor="let flat of floor.flatsArr">
              <div class="flat-box" *ngFor="let f of flat.info">
                <div class="flat-box__inner" [ngClass]="{'green' : f.isSale, 'cursor':f.flatConfigurationID}" (click)="f.flatConfigurationID?openFlat(f):''">
                  <div class="hover-text" *ngIf="f.isCornerFlat">Угловая квартира</div>
                  <div class="triangle" *ngIf="f.isCornerFlat"></div>
                  <span class="room">{{f.roomCountID?f.roomCountID:'-'}} {{f.roomCountID?'ком.':''}}</span>
                  <span class="flat-number">{{f.flatNumber?'':''}} {{f.flatNumber?'№':''}}{{f.flatNumber?f.flatNumber:'-'}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="other-rooms" (click)="openOtherRoom(otherRoom201)" *ngIf="otherRoom201">
            <div class="row">
              <span> {{otherRoom201?.info?.placeCount ? otherRoom201?.info?.placeCount : '-'}} мест</span>
              <span> {{otherRoom201?.info?.area ? otherRoom201?.info?.area : '-'}} кв.м.</span>
            </div>
          </div>
          
          <div class="other-rooms">
            <div class="row" *ngFor="let other1 of otherRooms1" (click)="openOtherRoom(other1)">
              <span> {{other1.info.placeCount ? other1.info.placeCount : '-'}} мест</span>
              <span> {{other1.info.area ? other1.info.area : '-'}} кв.м.</span>
            </div>
          </div>

          <div class="other-rooms" (click)="openOtherRoom(otherRoom202)" *ngIf="otherRoom202">
            <div class="row">
              <span> {{otherRoom202?.info?.placeCount ? otherRoom202?.info?.placeCount : '-'}} помещений</span>
              <span> {{otherRoom202?.info?.area ? otherRoom202?.info?.area : '-'}} кв.м.</span>
            </div>
          </div>

          <div class="other-rooms">
            <div class="row" *ngFor="let other3 of otherRooms3" (click)="openOtherRoom(other3)">
              <span> {{other3?.info?.placeCount ? other3?.info?.placeCount : '-'}} мест</span>
              <span> {{other3?.info?.area ? other3?.info?.area : '-'}} кв.м.</span>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>

</ng-container>

<ng-container *ngIf="loading">
  <div class="loading"></div>
</ng-container>

<app-modal-window *ngIf="flatFlag" [title]="appModalWindowTitle" [visible]="flatFlag" [height]="720" (close)="flatFlag = $event">
  <app-flats-modal [title]="appModalWindowTitle"  [flat_modal_info]="false" [otherRoomFlag]="otherRoomFlag" [buildingId]="buildingId" [flatId]="selectedFlatId" [flat]="selectedFlat" (confirmEvent)="reloadData($event)"></app-flats-modal>
</app-modal-window>

<app-modal-window [title]="'Завершение финансирования'" [visible]="changes" (close)="changes = $event"
  [width]="550" [height]="380">
  <div class="confirm">
    <div class="body">
      <div class="warning">
        <img src="assets/svg-icons/warning.svg" alt="">
      </div>
      <div class="text main"> Вы подтверждаете, что изменений за текущую неделю не было?</div>
      <!-- <div class="text secondary">
        {{lastNoChanges}}
      </div> -->
    </div>
    <div class="btns">
      <div class="btn btn-apply" (click)="acceptNoChanges()">ДА</div>
      <div class="btn btn-cancel" (click)="changes = false">НЕТ</div>
    </div>
  </div>
</app-modal-window>